import { observer } from "mobx-react-lite"
import { usePageContext } from "../context/PageContext";
import { useState } from "react";
import Form from "../ui/Form/Form";
import Input from "../ui/Input/Input";
import Button from "../ui/Button/Button";

const AuthPage = observer(() => {
    const { pageStore } = usePageContext();
    // const [username, setUsername] = useState('');
    // const [password, setPassword] = useState('');

    const handleSubmit = (e) => {
        e.preventDefault();
        window.location.href = 'https://t.me/offersbm_bot';
    };

    return (
        <div className="login_page">
            <Form onSubmit={handleSubmit} title={'Log In'}>
                {
                    /* <Input type="text" onChange={({ target }) => setUsername(target.value)} value={username} required placeholder="username" />
                    <Input type="password" onChange={({ target }) => setPassword(target.value)} value={password} required placeholder="password" /> */
                }
                <Button disabled={pageStore.isLoading} className={'btn_full'} type="submit">
                    Go through Telegram
                </Button>
            </Form>
        </div>
    )
})

export default AuthPage
